/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IStackItemStyles, ITextStyles } from "@fluentui/react";

export const dlFormJoinRequestLabelStyles: ITextStyles = {
  root: {
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "28px",
  },
};

export const dlStackItemStyles: IStackItemStyles = {
  root: {
    marginTop: "36px",
  },
};
